import React, { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import OperationalTable from '../../../../organisms/OperationalTable'
import AdminPage from '../../shared/AdminPage'
import Loading from '../../../../molecules/Loading'
import { useClassificationTagTypes } from '../../../../../api/coreData'
import Icon from '../../../../atoms/Icon'
import Tooltip from '../../../../atoms/Tooltip'

const ProductsTagsTab = () => {
  const { data, isLoading, isError, error } = useClassificationTagTypes({ includes: { classificationTags: true } })
  const history = useHistory()
  const onClickRow = useCallback(
    (row) => {
      if (row.original) {
        history.push(`/admin/data-maintenance/tags/product/${row.original.classificationTagTypeId}`)
      }
    },
    [history]
  )
  const defaultColumnConfig = {
    columns: [
      { Header: 'Id', accessor: 'classificationTagTypeId', type: 'string' },
      { Header: 'Classification Tag Type', accessor: 'longName', type: 'string' },
      {
        Header: 'Required',
        accessor: 'required',
        type: 'bool',
        Cell: ({ row }) => (row.original.required ? 'Yes' : 'No')
      },
      {
        Header: 'Default Tag',
        accessor: 'defaultTagId',
        Cell: ({ row }) => DefaultTagCell({
          tagTypeData: row.original
        })
      }
    ],
    defaultSort: [{ id: 'classificationTagTypeId', desc: false }]
  }
  if (!data) return null
  if (isLoading) return <Loading />
  return (
    <AdminPage>
      <OperationalTable.Wrapper>
        <OperationalTable
          variant='v2'
          mode='auto'
          itemName='Product Tags Types'
          onRowClick={(data) => onClickRow(data)}
          columns={defaultColumnConfig.columns}
          defaultSort={defaultColumnConfig.defaultSort}
          data={data || []}
          isLoading={isLoading}
          isError={isError}
          error={error}
        />
      </OperationalTable.Wrapper>
    </AdminPage>
  )
}

const DefaultTagCell = ({ tagTypeData }) => {
  const defaultExistsOutsideList =
    !!tagTypeData.defaultTagId &&
    !tagTypeData.classificationTags.some(
      (tag) => tag.classificationTagId === tagTypeData.defaultTagId
    )
  const defaultTagName = tagTypeData.classificationTags.find(
    (tag) => tag.classificationTagId === tagTypeData.defaultTagId
  )?.longName

  return (
    <div className='flex flex-row items-center gap-2'>
      {defaultTagName && <span>{defaultTagName}</span>}
      {defaultExistsOutsideList && (
        <Tooltip title='Default Tag set, but is not included in Type.'>
          <div>
            <Icon name='warning' color='orange' />
          </div>
        </Tooltip>
      )}
    </div>
  )
}

DefaultTagCell.propTypes = {
  tagTypeData: PropTypes.object
}

export default ProductsTagsTab
